var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256.00098 256.00098",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.98509,201.34409,45.14832,228.94793a8,8,0,0,1-13.14783-6.12372V64.00049a8,8,0,0,1,8-8h176a8,8,0,0,1,8,8v128a8,8,0,0,1-8,8H81.67142Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216.00049,48.00049h-176a16.01833,16.01833,0,0,0-16,16V222.82422a15.85,15.85,0,0,0,9.24414,14.5039,16.07979,16.07979,0,0,0,6.79785,1.52149,15.88972,15.88972,0,0,0,10.25293-3.77783L82.05127,208.377l1.03223-.37646h132.917a16.018,16.018,0,0,0,16-16v-128A16.01833,16.01833,0,0,0,216.00049,48.00049Zm0,144H81.67139a8.0053,8.0053,0,0,0-2.74121.48388l-3.68262,1.34278a7.99607,7.99607,0,0,0-2.41016,1.39306L40.00049,222.81885V64.00049h176Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.00049,120h64a8,8,0,0,0,0-16h-64a8,8,0,0,0,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.00049,152h64a8,8,0,0,0,0-16h-64a8,8,0,0,0,0,16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.331d0aefab46ba2322cbcaace7bff3b8.svg";
export { ForwardRef as ReactComponent };